module.exports = __webpack_public_path__ + "static/media/throwing.85854030.png";